import React, { useState } from "react";
import { Modal, Button, Form, Space, Result, Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { SelectProps } from "antd/lib/select";
import { useStepsForm } from "sunflower-antd";

interface IModalProps {
  show: boolean;
  claimId: any;
  showModal: Function;
  handleAdd: Function;
}

const bank: SelectProps["options"] = [
  {
    label: "ABSA",
    value: "ABSA",
  },
  {
    label: "Access",
    value: "Access",
  },
  {
    label: "African Bank",
    value: "African Bank",
  },
  {
    label: "Bidvest Bank",
    value: "Bidvest Bank",
  },
  {
    label: "Capitec",
    value: "Capitec",
  },
  {
    label: "FinBond",
    value: "FinBond",
  },
  {
    label: "FNB",
    value: "FNB",
  },
  {
    label: "Nedbank",
    value: "Nedbank",
  },
  {
    label: "Standard Bank",
    value: "Standard Bank",
  },
  {
    label: "TymeBank",
    value: "TymeBank",
  },
];

const ApproveClaimModal: React.FC<IModalProps> = ({
  show,
  claimId,
  showModal,
  handleAdd,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);

      const response = await handleAdd(
        {
          ...values,
        },
        claimId
      );

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 2,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 0 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const formList: any = [
    <>
      <Form.Item name="AccountNumber" label="Account Number">
        <Input size="large" placeholder="Account Number" />
      </Form.Item>

      <Form.Item name="AccountType" label="Account Type">
        <Input size="large" placeholder="Account Type" />
      </Form.Item>

      <Form.Item name="Bank" label="Bank">
        <Select
          id="Bank"
          options={bank}
          size="large"
          style={{ width: "100%" }}
          placeholder="Bank"
        />
      </Form.Item>

      <Form.Item name="BranchCode" label="Branch Code">
        <Input size="large" placeholder="Branch Code" />
      </Form.Item>

      <Form.Item name="Notes" label="Notes">
        <TextArea size="large" id="Notes" placeholder="Notes" />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            loading={loading}
            style={{ marginBottom: 10 }}
            block
            size="large"
            onClick={() => {
              submit().then((result: any) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  console.log(current);
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="Approve Claim"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={600}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ApproveClaimModal;
